define('home/collections/FollowRecommendationCollection',[
    'underscore',
    'backbone',

    'core/UniqueModel',
    'home/models/FollowRecommendation',
], function (
    _,
    Backbone,

    UniqueModel,
    FollowRecommendation
) {
    'use strict';

    return Backbone.Collection.extend({
        model: UniqueModel.boundModel(FollowRecommendation),

        initialize: function (_models, options) {
            this.expander = options.expander;
        },

        parse: function (response) {
            response = response.response;
            return _.map(response.items, function (followRecommendation) {

                return {
                    object: this.expander(response.objects, followRecommendation.id),
                    reason: followRecommendation.reason,
                };
            }, this);
        },
    });
});

